const MODAL_SELECTOR = '#invitation-modal';
const MODAL_INVITER_SELECTOR = '#invitation-modal-inviter';
const BANNER_SELECTOR = '#invitation-banner';
const BANNER_INVITER_SELECTOR = '#invitation-banner-inviter';
const INVITATION_CODE_INPUT_SELECTOR = '#register-invitation-code';
const DEFAULT_TEXT_SELECTOR = '#register-default-text';
const REGISTRATION_FORM_SELECTOR = '#registration-form';
const GOOUT_WIDGET_SELECTOR = '#goout-widget';
const URL_PARAM_NAME = 'inv';

/**
 * Mapping of invitation codes to inviter names.
 */
const INVITER_NAMES = {
    'LKCB': 'Lukáš Cibulka',
    'RDPL': 'Radek Plašil',
    'DVMR': 'David Moráň',
    'TMGR': 'Tomáš Grmela',
    'VTHS': 'Vít Hasenöhrl',
    'MKDZ': 'Marek Ditz',
    'SBTS': 'Sabina Turšnerová',
};

const UI_TEXTS = {
    cs: {
        invitesYou: 'vás zve na Day One',
        bannerText: 'Na základě osobního pozvání získáváte vstup na Day One, ještě před zahájením veřejného prodeje.',
    },
    en: {
        invitesYou: 'invites you to Day One',
        bannerText: 'Based on a personal invitation, you gain access to Day One before public sales begin.',
    },
};

/**
 * Resolve localized UI text by page language.
 *
 * @return {Object}
 */
function getUiTexts() {
    const lang = document.documentElement.lang;

    if (lang === 'en') {
        return UI_TEXTS.en;
    }

    return UI_TEXTS.cs;
}

/**
 * Get invitation code from URL parameter.
 *
 * @return {string|null}
 */
function getInvitationCode() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get(URL_PARAM_NAME);

    if (!code || code.trim() === '') {
        return null;
    }

    return code.trim();
}

/**
 * Escape HTML special characters to prevent XSS.
 *
 * @param {string} str
 * @return {string}
 */
function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

/**
 * Get inviter display name from code.
 *
 * @param {string} code
 * @return {string|null}
 */
function getInviterName(code) {
    return INVITER_NAMES[code.toUpperCase()] || null;
}

/**
 * Show invitation modal with the inviter name.
 *
 * @param {string} inviterName
 * @return {void}
 */
function showInvitationModal(inviterName) {
    const modalElement = document.querySelector(MODAL_SELECTOR);
    const inviterElement = document.querySelector(MODAL_INVITER_SELECTOR);

    if (!modalElement || !inviterElement) {
        console.error('Invitation modal elements not found.');
        return;
    }

    inviterElement.textContent = inviterName;

    const modal = new bootstrap.Modal(modalElement);
    modal.show();
}

/**
 * Show invitation banner above the registration form.
 *
 * @param {string} inviterName
 * @return {void}
 */
function showInvitationBanner(inviterName) {
    const bannerElement = document.querySelector(BANNER_SELECTOR);
    const inviterElement = document.querySelector(BANNER_INVITER_SELECTOR);

    if (!bannerElement || !inviterElement) {
        console.error('Invitation banner elements not found.');
        return;
    }

    inviterElement.textContent = inviterName;
    bannerElement.classList.add('is-visible');
}

/**
 * Set invitation code in hidden form field.
 *
 * @param {string} invitationCode
 * @return {void}
 */
function setInvitationCodeField(invitationCode) {
    const inputElement = document.querySelector(INVITATION_CODE_INPUT_SELECTOR);

    if (!inputElement) {
        console.error('Invitation code input not found.');
        return;
    }

    inputElement.value = invitationCode;
}

/**
 * Hide default registration text when invitation is active.
 *
 * @return {void}
 */
function hideDefaultText() {
    const textElement = document.querySelector(DEFAULT_TEXT_SELECTOR);

    if (textElement) {
        textElement.style.display = 'none';
    }
}

/**
 * Show GoOut widget for ticket purchase.
 *
 * @return {void}
 */
function showGoOutWidget() {
    const widgetElement = document.querySelector(GOOUT_WIDGET_SELECTOR);

    if (widgetElement) {
        widgetElement.style.display = 'block';
    }
}

/**
 * Hide registration form when no invitation code.
 *
 * @return {void}
 */
function hideRegistrationForm() {
    const formElement = document.querySelector(REGISTRATION_FORM_SELECTOR);

    if (formElement) {
        formElement.style.display = 'none';
    }
}

/**
 * Initialize invitation system.
 *
 * @return {void}
 */
export function initInvitation() {
    const invitationCode = getInvitationCode();

    if (!invitationCode) {
        showGoOutWidget();
        hideRegistrationForm();
        return;
    }

    const inviterName = getInviterName(invitationCode);

    if (!inviterName) {
        showGoOutWidget();
        hideRegistrationForm();
        return;
    }

    setInvitationCodeField(invitationCode);
    hideDefaultText();
    showInvitationBanner(inviterName);
    showInvitationModal(inviterName);
}
